import { createContext, useContext, useEffect, useState } from 'react';
import { getNavigation, saveNavigation } from '../utils/navigationHelper';

const NavigationContext = createContext(null);

const initial = {
  activeAppKey: null,
  activeProgramId: null,
  activeResourceId: null,
  isSidebarOpen: true
};

export const NavigationContextProvider = ({ children }) => {
  const [navigationContext, setNavigationContext] = useState(getNavigation() || initial);

  // Save navigation context to local storage
  useEffect(() => {
    if (!navigationContext) return;

    const shouldSave =
      navigationContext.activeAppKey !== null ||
      typeof navigationContext.isSidebarOpen === 'boolean';

    if (shouldSave) {
      saveNavigation(navigationContext);
    }
  }, [navigationContext]);

  /**
   * Fonction générique pour définir la vue active.
   * {string} appKey - La clé de l'application (ex: 'program', 'news', etc.)
   * {object|null} targetObject - L'objet cible contenant l'ID.
   * {string} targetIdKey - Le nom du champ à utiliser pour l'ID.
   */
  const setActiveView = (appKey, targetObject, targetIdKey) => {
    setNavigationContext((prevContext) => {
      const newContext = {
        ...prevContext,
        activeAppKey: appKey
      };

      if (targetObject && targetObject.id) {
        newContext[targetIdKey] = targetObject.id;
      } else {
        newContext[targetIdKey] = null;
      }

      return newContext;
    });
  };

  const toggleSidebar = () => {
    setNavigationContext((prev) => ({
      ...prev,
      isSidebarOpen: !prev.isSidebarOpen
    }));
  };

  return (
    <NavigationContext.Provider
      value={{
        navigationContext,
        setNavigationContext,
        setActiveView,
        toggleSidebar
      }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigationContext must be used within a NavigationContextProvider');
  }
  return context;
};
